import { register, CloudObject, File as OFile, defineProperty, defineRelation } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class Template extends CloudObject {

    /**
     * @return {boolean}
     */
    getDisabled() {
        return this.get(Template.disabledProp);
    }
}

// Hardcoded tags
register('01880fe142dd3967b89f', Template);
Template.disabledProp = defineProperty('01880fe16fe5765fc1d7');
Template.documentRel = defineRelation('01880fe1b04e9597d869', Template, OFile);
